export default __webpack_public_path__ + "static/media/GRIDIcon.a6be2989.svg";